/* eslint-disable */
export const nationalities = '/nationalities';
export const nationality = (nationalitId: number) =>
  `${nationalities}/${nationalitId}`;

